import state from './commonState'
import mutations from './commonMutations'
import getters from './commonGetters'
import actions from './commonActions'

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions
}
